import cx from 'classnames';
import React from 'react';
import { connect } from 'react-redux';

// eslint-disable-next-line
const Notification = React.createClass({

    displayName: 'Notification',

    render() {

        const notificationClasses = cx({
            'notification': true,
            'btn': true,
            'btn-primary': true,
            'd-none': this.props.notification === ''
        });

        return (
            <div className={ notificationClasses }>
                { this.props.notification }
            </div>
        );
    }

});

export default connect( state => ({
    notification: state.notification.notificationText
}))( Notification );



// WEBPACK FOOTER //
// ./src/components/notification/index.js